import { Card } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  vendordataSelector,
  vendordata_updateActiveVendor
} from "reducers/vendordata/vendordata";
import { formatData } from "./VendordataHelper";
import {
  appdataSelector,
  appdata_getRegionsForCountry
} from "reducers/appdata/appdata";
import { useEffect } from "react";
function VendordataEditableGeneral(props) {
  const vendordata = useSelector(vendordataSelector);
  const appdata = useSelector(appdataSelector);
  const dispatch = useDispatch();
  const languageSuffix = props.languageSuffix;
  const inputWidth = "100%";

  const styles = {
    myInput: {
      width: inputWidth
    },
    mySelect: {
      height: 30,
      width: inputWidth
    }
  };

  useEffect(() => {
    if (
      vendordata.activeVendor.master &&
      vendordata.activeVendor.COMPANY.COMP_COUNTRY
    ) {
      dispatch(
        appdata_getRegionsForCountry(
          vendordata.activeVendor.COMPANY.COMP_COUNTRY
        )
      );
    }
  }, []);

  console.log("editablegeneral", vendordata.activeVendor.COMPANY);

  let part = { ...vendordata.vendorParts.COMPANY };
  if (languageSuffix != "") {
    delete part["COMP_PROF"];
    delete part["COMP_PTERMS"];
    delete part["COMP_MEMO"];
    delete part["COMP_PMETHOD"];
    delete part["COMP_TYPE"];
    delete part["COMP_REG_NO"];
    delete part["COMP_VAT_REG"];
    delete part["COMP_RECON_ACCT"];
    delete part["COMP_CLERK"];
  }


  let data = vendordata.activeVendor.COMPANY ? formatData("COMPANY", part, appdata, vendordata, languageSuffix) : {};

  const handleChange = (event, key) => {
    console.log("handle change", event.target.value, key);
    if (key == "COMP_COUNTRY") {
      console.log("country selected");
      dispatch(appdata_getRegionsForCountry(event.target.value));
    }
    dispatch(
      vendordata_updateActiveVendor({
        part: "COMPANY",
        key: key,
        value: event.target.value
      })
    );
  };

  return (
    <Card className="p-4 mt-2" key="Card">
      <div className="row border-bottom mb-2 pb-2">
        <div className="col-3 d-none d-md-block">Label</div>
        <div className="col-6 col-md-4">New value</div>
        {appdata.activeRequestType != "NV" && (
          <div className="col-6 col-md-5">Original value</div>
        )}
      </div>

      {Object.keys(data).map(key => {
        //key = languageSuffix ? key + "_" + languageSuffix : key
        let typeIsDropdown = data[key].hasOwnProperty("key") ? true : false;
        let alternativeText = data[key].hasOwnProperty("alternativeText")
          ? true
          : false;
        let highlight = false;

        if (appdata.highlightRequiredFields) {
          if (vendordata.incompleteRequiredFields.hasOwnProperty("COMPANY") && vendordata.incompleteRequiredFields.COMPANY.hasOwnProperty(key)) {
            highlight = true;
          }
        }

        let highlightInfo = false;
        if (appdata.activeRequestType != "NV") {
          if (data[key].active != data[key].sap) {
            highlightInfo = true;
          }
        }

        let cls = "row mt-1 mb-1";

        if (highlight){
            cls += " border border-danger"
        }
        if (!highlight && highlightInfo){
            cls += " border border-info"
        }

        console.log("data[key]", data[key]);

        return (
          <div className={cls} key={"rowpart" + key} >
            <div className="col-3 d-none d-md-flex align-items-center" key={"label" + key}>
              <b>
                {data[key].label} {data[key].required ? "*" : ""}
              </b>
            </div>
            {typeIsDropdown && (
              <div className="col-6 col-md-4" key={"dropdown" + key}>
                {" "}
                <select
                  /* disabled={disabled} */
                  key={key + "selection"}
                  /* id={selectkey} */
                  /* name={seltype + "selection"} */
                  className="d-print-none"
                  style={styles.mySelect}
                  onChange={event => {
                    //props.handleSelect(event, part);
                    handleChange(
                      event,
                      languageSuffix ? key + "_" + languageSuffix : key
                    );
                  }}
                  value={data[key].value}
                >
                  <option hidden></option>
                  {data[key].list &&
                    data[key].list.map((item, keyIntern) => {
                      return (
                        <option
                          key={key + "_option" + keyIntern}
                          value={item[data[key].listKeys[0]]}
                        >
                          {item[data[key].listKeys[0]] +
                            " - " +
                            item[data[key].listKeys[1]]}
                        </option>
                      );
                    })}
                </select>
              </div>
            )}
            {!typeIsDropdown && !alternativeText && (
              <div className="col-6 col-md-4">
                <input
                  disabled={false}
                  maxLength={data[key]["maxLength"] ? data[key]["maxLength"] : null}
                  style={styles.myInput}
                  onChange={event => {
                    handleChange(
                      event,
                      languageSuffix ? key + "_" + languageSuffix : key
                    );
                  }}
                  /* hidden={hidden} */
                  key={"input" + key}
                  /* id={key} */
                  type="text"
                  value={data[key].active ? data[key].active : ""}
                /* maxLength={maxChars ? maxChars : null} */
                ></input>
              </div>
            )}
            {alternativeText && (
              <div className="col-6 col-md-4" key={"alternativeText" + key}>
                {data[key].alternativeText}
              </div>
            )}
            <div className="col-6 col-md-5 d-flex align-items-center" style={{ textDecoration: highlightInfo ? "line-through" : "" }}>{data[key].sap}</div>
          </div>
        );
      })}
    </Card>
  );
}

export default VendordataEditableGeneral;
